import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import redirectWithReturn from '../../utils/redirectWithReturn'
import { useMe } from '../user'

export const UserAuthContext = React.createContext({
  user: null,
  login: (credentials, callback) => {},
  logout: (callback) => {},
  error: null,
  setEnabled: (bool) => {},
  enabled: false,
  setFirstRun: (bool) => {},
  isLoading: false,
  isAuthorized: false,
})

export function UserAuthProvider({ children }) {
  const navigate = useNavigate()
  const location = useLocation()

  const { firstRun, user, error, fetchUser, setEnabled, enabled, setFirstRun, isLoading } = useMe()

  useEffect(() => {
    if (user && user.from) {
      const state = { ...(location?.state ?? {}) }
      delete state.from
      navigate(user.from || '/', { replace: true, state })
      delete user.from
    }

    // eslint-disable-next-line
  }, [user])

  let login = () => redirectWithReturn('/login', location)

  let logout = () => redirectWithReturn('/logout', location)

  let isAuthorized = Boolean(user?._id)

  return (
    <UserAuthContext.Provider
      value={{
        user,
        login,
        logout,
        error,
        fetchUser,
        setEnabled,
        enabled,
        setFirstRun,
        isLoading,
        isAuthorized,
      }}
    >
      {firstRun ? null : children}
    </UserAuthContext.Provider>
  )
}

export function useAuth() {
  return React.useContext(UserAuthContext)
}
